/* eslint-disable no-unused-vars */
import { useEffect, useState, useCallback } from "react";
import api from "../../../services/api.service";
// ^^^ ตรง path และชื่อไฟล์ปรับตามโครงสร้างโปรเจกต์ของคุณ

// ตัวอย่าง import Modal ต่าง ๆ
import AddUserModal from "../../modals/AddUserModal";
import EditUserModal from "../../modals/EditUserModal";
import ConfirmRemoveModal from "../../modals/ConfirmRemoveModal";
import ChangePasswordModal from "../../modals/ChangePasswordModal";
import PaginationUser from "../../modals/PaginationModal"; // หรืออาจอยู่โฟลเดอร์อื่นก็ได้
import GeneralModal from "../../modals/GeneralModal";

function UserManagement() {
  // -----------------------------
  // State สำหรับควบคุม Modal
  // -----------------------------
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [showEditUserModal, setShowEditUserModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);

  // -----------------------------
  // State สำหรับข้อมูล User
  // -----------------------------
  const [users, setUsers] = useState([]);
  const [newUser, setNewUser] = useState({
    email: "",
    password: "",
    hospitalNameEN: "",
    role: "",
    isActive: true,
  });
  const [editUser, setEditUser] = useState(null);
  const [deleteUserId, setDeleteUserId] = useState(null);

  // -----------------------------
  // State สำหรับฟิลเตอร์, การค้นหา, การแสดงผล
  // -----------------------------
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // สำหรับการเปลี่ยนรหัสผ่าน
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [currentUserRole, setCurrentUserRole] = useState("");
  const [passwordData, setPasswordData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  // -----------------------------
  // State สำหรับ Pagination
  // -----------------------------
  const [currentPage, setCurrentPage] = useState(1);
  const [usersPerPage, setUsersPerPage] = useState(8);
  const [generalModal, setGeneralModal] = useState({
    visible: false,
    message: "",
    isSuccess: true,
    onClose: null,
  });
  const [hospitalOptions, setHospitalOptions] = useState([]);

  const showGeneralModal = (message, isSuccess = true, onCloseCallback = null) => {
    setGeneralModal({
      isVisible: true,
      message,
      isSuccess,
      onClose: onCloseCallback,
    });
  };

  const handleCloseGeneralModal = () => {
    // กำหนดให้ state ของ General Modal ซ่อน (isVisible: false)
    setGeneralModal(prev => ({ ...prev, isVisible: false }));
    // หากมี callback ใน onClose ก็เรียกใช้งาน (ถ้าจำเป็น)
    if (generalModal.onClose) {
      generalModal.onClose();
    }
  };

  // =========================================================
  // 1) ฟังก์ชันดึงข้อมูลผู้ใช้จาก Backend
  // =========================================================
  const fetchUsers = async () => {
    setIsLoading(true);
    try {
      // ถ้า api.service.js ตั้ง baseURL ไว้แล้ว 
      // เราเรียกแค่ /users/ ได้เลย
      const response = await api.get("/users/");
      // สมมติรูปแบบ response.data = { users: [...] }
      setUsers(response.data.users || []);
      setFilteredUsers(response.data.users || []);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // =========================================================
  // 2) ฟังก์ชันสำหรับการกรองข้อมูลผู้ใช้ตามเงื่อนไข
  // =========================================================
  const filterUsers = () => {
    let filtered = [...users];
    if (searchQuery) {
      filtered = filtered.filter(
        (user) =>
          user.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
          user.hospitalName.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }
    if (selectedRole) {
      filtered = filtered.filter((user) => user.role === selectedRole);
    }
    if (selectedStatus) {
      const isActive = selectedStatus === "true";
      filtered = filtered.filter((user) => user.isActive === isActive);
    }
    setFilteredUsers(filtered);
    setCurrentPage(1); // รีเซ็ตไปหน้าที่ 1 ทุกครั้งที่มีการกรองใหม่
  };

  // เรียก filterUsers เมื่อ state ที่เกี่ยวข้องเปลี่ยน
  useEffect(() => {
    filterUsers();
    // eslint-disable-next-line
  }, [searchQuery, selectedRole, selectedStatus, users]);

  // =========================================================
  // 3) Pagination Logic
  // =========================================================
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < Math.ceil(filteredUsers.length / usersPerPage)) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  // =========================================================
  // 4) ฟังก์ชันเพิ่มผู้ใช้ใหม่
  // =========================================================
  const [errors, setErrors] = useState({});

  const validateForm = (userData) => {
    const errors = {};

    if (!userData.email || userData.email.trim() === '') {
      errors.email = "Email is required";
    } else {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailPattern.test(userData.email)) {
        errors.email = "Invalid email format";
      }
    }

    if (!userData.password || userData.password.trim().length < 8 || userData.password.trim() === '') {
      errors.password = "Password is required and must be at least 8 characters long";
    } else {
      const hasUpperCase = /[A-Z]/.test(userData.password);
      const hasLowerCase = /[a-z]/.test(userData.password);
      const hasNumber = /[0-9]/.test(userData.password);
      const isLongEnough = userData.password.length >= 8;

      if (!hasUpperCase || !hasLowerCase || !hasNumber || !isLongEnough) {
        errors.password = "Password must contain at least one uppercase letter, one lowercase letter, and one number";
      }
    }

    if (!userData.hospitalName || userData.hospitalName.trim() === '') {
      errors.hospitalName = "Hospital Name is required";
    }

    return errors;
  };

  const handleAddUser = async () => {
    const validationErrors = validateForm(newUser);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    try {
      setErrors({});
      // เรียก POST ไปยัง /users/create
      await api.post("/users/create", newUser);
      // เมื่อสำเร็จให้ fetchUsers อีกครั้ง
      await fetchUsers();
      // ปิดโมดอล และเคลียร์ state
      handleCancelAddUser();
      showGeneralModal("User added successfully", true, () => {
    });
    } catch (error) {
      console.error("Error adding user:", error);
      const errorMessage = error.response?.data?.message || "";
      // showGeneralModal(errorMessage, false);
      if (errorMessage) {
        // เช็คข้อความ error จาก backend
        const validationErrors = {
          email: errorMessage.includes("email") ? "Email is required" : "",
          password: errorMessage.includes("password") ? "Password is required" : "",
          hospitalNameEN: errorMessage.includes("hospitalName") ? "Hospital Name is required" : "",
          role: errorMessage.includes("role") ? "User Role is required" : "",
        };
        // กรอง field ที่ว่างออกไป
        const filteredErrors = Object.fromEntries(
          Object.entries(validationErrors).filter(([_, value]) => value)
        );
        setErrors(filteredErrors);
      } else {
        setErrors({ general: "Failed to add user. Please try again." });
      }
    }
  };

  useEffect(() => {
    const fetchHospitals = async () => {
      try {
        const response = await api.get("/hospitals/");
        const options = response.data.hospitals.map((hosp) => ({
          value: hosp.hospitalNameEN,
          label: hosp.hospitalNameEN,
        }))
        setHospitalOptions(options);
      } catch (error) {
        console.error("Error fetching hospitals:", error);
      }
    };
    fetchHospitals();
  }, []);

  const handleCancelAddUser = () => {
    setShowAddUserModal(false);
    setNewUser({
      email: "",
      password: "",
      hospitalName: "",
      role: "",
      isActive: true,
    });
    setErrors({});
  };

  // =========================================================
  // 5) ฟังก์ชันแก้ไขผู้ใช้
  // =========================================================
  const handleEditUser = (userId) => {
    const user = users.find((u) => u._id === userId);
    if (user) {
      setEditUser(user);
      setShowEditUserModal(true);
    }
  };

  const handleSaveEditUser = async () => {
    try {
      await api.put(`/users/edit/${editUser._id}`, {
        hospitalName: editUser.hospitalName,
        role: editUser.role,
        isActive: editUser.isActive,
      });
      await fetchUsers();
      setShowEditUserModal(false);
      setEditUser(null);
      showGeneralModal("User updated successfully", true);
    } catch (error) {
      console.error("Error updating user:", error);
      // ปิด Edit User Modal ก่อนแสดง General Modal
      setShowEditUserModal(false);
      const errorMessage = error.response?.data?.message || "Failed to update user. Please try again.";
      showGeneralModal(errorMessage, false, () => {
        // สามารถเปิด modal หลักอีกครั้งถ้าต้องการให้ผู้ใช้แก้ไขต่อ
        setShowEditUserModal(true);
      });
    }
  };

  // =========================================================
  // 6) ฟังก์ชันลบผู้ใช้
  // =========================================================
  const handleDeleteUser = async () => {
    try {
      await api.delete(`/users/${deleteUserId}`);
      // แทนที่จะ fetchUsers ใหม่ทั้งหมด อาจลบออกจาก state โดยตรงได้
      setUsers((prev) => prev.filter((user) => user._id !== deleteUserId));
      setShowConfirmModal(false);
      setDeleteUserId(null);
      showGeneralModal("User deleted successfully", true);
    } catch (error) {
      console.error("Error deleting user:", error);
      showGeneralModal(error.response?.data?.message || "Failed to delete user. Please try again.", false);
    }
  };

  const handleOpenDeleteModal = (userId) => {
    setDeleteUserId(userId);
    setShowConfirmModal(true);
  };

  const handleCloseModal = () => {
    setShowConfirmModal(false);
    setShowChangePasswordModal(false);
    setDeleteUserId(null);
  };

  // =========================================================
  // 7) ฟังก์ชันเปลี่ยนรหัสผ่าน
  // =========================================================
  const handleOpenChangePasswordModal = (userId, userRole) => {
    setSelectedUserId(userId);
    setCurrentUserRole(userRole);
    setShowChangePasswordModal(true);
  };

  const handleCancelChangePassword = () => {
    // ปิด Change Password Modal
    setShowChangePasswordModal(false);
    // รีเซ็ตค่า passwordData
    setPasswordData({
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    });
    // รีเซ็ต state ของ General Modal ให้เป็นค่าเริ่มต้น โดยไม่เรียก callback onClose
    setGeneralModal({
      isVisible: false,
      message: "",
      isSuccess: true,
      onClose: null,
    });
  };
  const handleChangePassword = async () => {
    // Validate เบื้องต้น: newPassword กับ confirmPassword ต้องตรงกัน
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      // ปิด Change Password Modal ก่อน แล้วเปิด General Modal error พร้อม callback เพื่อเปิด modal ใหม่
      setShowChangePasswordModal(false);
      showGeneralModal(
        "New password and confirm password do not match", 
        false,
        () => {
          setShowChangePasswordModal(true);
        }
      );
      return;
    }
  
    try {
      // สำหรับ admin หรือ systemAdmin ไม่ต้องส่ง oldPassword
      const isAdminOrSystemAdmin =
        currentUserRole === "systemAdmin" || currentUserRole === "admin";
  
      const requestBody = isAdminOrSystemAdmin
        ? { newPassword: passwordData.newPassword }
        : {
            oldPassword: passwordData.oldPassword,
            newPassword: passwordData.newPassword,
          };
  
      const response = await api.post(
        `/auth/change-password/${selectedUserId}`,
        requestBody
      );
  
      // เมื่อเปลี่ยนรหัสผ่านสำเร็จให้ปิด Change Password Modal
      setShowChangePasswordModal(false);
  
      // แสดง General Modal success 
      // ใน callback เมื่อผู้ใช้กด Close เราจะรีเซ็ต state โดยไม่เปิด modal สำหรับแก้ไขต่อ
      showGeneralModal(
        response.data.message || "Change password successfully", 
        true, 
        () => {
          // Reset state ของ passwordData
          setPasswordData({
            oldPassword: "",
            newPassword: "",
            confirmPassword: "",
          });
        }
      );
    } catch (error) {
      console.error("Error changing password:", error);
      // ปิด Change Password Modal ก่อนแสดง error
      setShowChangePasswordModal(false);
      const errorMessage =
        error.response?.data?.message ||
        "Failed to change password. Please try again.";
      // แสดง General Modal error พร้อม callback เพื่อเปิด modal ให้ผู้ใช้แก้ไขต่อ
      showGeneralModal(errorMessage, false, () => {
        setShowChangePasswordModal(true);
      });
    }
  };

  // =========================================================
  // 8) ฟังก์ชัน Clear Filters
  // =========================================================
  const clearFilters = () => {
    setSearchQuery("");
    setSelectedRole("");
    setSelectedStatus("");
  };

  // =========================================================
  // สุดท้ายคือส่วน Render
  // =========================================================
  return (
<>
      <div className="container mx-auto max-w-screen-xl px-3 sm:px-6 md:px-8 py-6 sm:py-8 my-4 sm:my-6">
        <div className="bg-white shadow-md rounded-xl p-4 sm:p-6">
          {/* Header */}
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
            <div className="flex items-baseline">
              <i className="fas fa-user text-xl sm:text-2xl mr-3 sm:mr-4"></i>
              <h1 className="text-lg sm:text-xl font-bold">User Management</h1>
            </div>
            <button
              className="btn btn-neutral bg-black w-full sm:w-auto text-sm sm:text-base"
              onClick={() => setShowAddUserModal(true)}
            >
              <i className="fas fa-user-plus mr-2"></i>
              Add User
            </button>
          </div>

          {/* Search & Filters */}
          <div className="mt-6">
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
              <div className="relative flex-1">
                <input
                  type="text"
                  placeholder="Search by email or hospital name"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="input input-bordered w-full pl-10 text-sm sm:text-base"
                />
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
                  <i className="fas fa-search"></i>
                </span>
              </div>
              
              <select
                value={selectedRole}
                onChange={(e) => setSelectedRole(e.target.value)}
                className="select select-bordered w-full sm:w-40 text-sm sm:text-base"
              >
                <option value="">All Roles</option>
                <option value="admin">Admin</option>
                <option value="user">Members</option>
                <option value="guest">Guest</option>
              </select>
              
              <select
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
                className="select select-bordered w-full sm:w-40 text-sm sm:text-base"
              >
                <option value="">All Status</option>
                <option value="true">Active</option>
                <option value="false">Inactive</option>
              </select>
              
              <button 
                className="btn btn-outline btn-error w-full sm:w-auto text-sm sm:text-base whitespace-nowrap"
                onClick={clearFilters}
              >
                <i className="fa-solid fa-filter-circle-xmark mr-2"></i>
                <span className="hidden sm:inline">Clear Filters</span>
                <span className="sm:hidden">Clear</span>
              </button>
            </div>

            {/* Loading & Data Table */}
            {isLoading ? (
              <div className="flex justify-center items-center h-48 sm:h-64">
                <div className="flex flex-col items-center">
                  <span className="loading loading-spinner loading-lg text-primary"></span>
                  <p className="mt-4 text-gray-600 text-sm sm:text-base">Loading users data...</p>
                </div>
              </div>
            ) : currentUsers.length === 0 ? (
              <div className="flex justify-center items-center h-48 sm:h-64">
                <p className="text-gray-500 text-sm sm:text-base">No users found</p>
              </div>
            ) : (
              <div className="mt-6 overflow-x-auto">
                <table className="table table-pin-rows table-pin-cols w-full text-sm sm:text-base">
                  <thead>
                    <tr>
                      <th className="text-xs sm:text-sm">#</th>
                      <th className="text-xs sm:text-sm">Email</th>
                      <th className="text-xs sm:text-sm hidden md:table-cell">Hospital</th>
                      <th className="text-xs sm:text-sm hidden lg:table-cell">Role</th>
                      <th className="text-xs sm:text-sm">Status</th>
                      <th className="text-xs sm:text-sm hidden md:table-cell">Last Login</th>
                      <th className="text-xs sm:text-sm">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentUsers.map((user, index) => (
                      <tr key={user._id}>
                        <th className="text-xs sm:text-sm">{indexOfFirstUser + index + 1}</th>
                        <td className="text-xs sm:text-sm break-all">{user.email}</td>
                        <td className="text-xs sm:text-sm hidden md:table-cell">{user.hospitalName}</td>
                        <td className="text-xs sm:text-sm hidden lg:table-cell">
                          <span
                            className={`badge text-xs ${
                              user.role === "systemAdmin"
                                ? "badge-warning"
                                : user.role === "user" || user.role === "guest"
                                  ? "badge"
                                  : "badge-neutral"
                            }`}
                          >
                            {user.role === "systemAdmin"
                              ? "System Admin"
                              : user.role === "admin"
                                ? "Admin"
                                : user.role === "user"
                                  ? "Members"
                                  : "Guest"}
                          </span>
                        </td>
                        <td className="text-xs sm:text-sm">
                          <span
                            className={`badge text-xs ${
                              user.isActive
                                ? "badge-accent badge-outline"
                                : "badge-error badge-outline"
                            }`}
                          >
                            {user.isActive ? "Active" : "Inactive"}
                          </span>
                        </td>
                        <td className="text-xs sm:text-sm hidden md:table-cell whitespace-nowrap">
                          {user.LastLogin
                            ? new Date(user.LastLogin).toLocaleDateString("en-US", {
                                month: "short",
                                day: "numeric",
                                year: "numeric",
                              })
                            : "-"}
                        </td>
                        <td>
                          <div className="flex gap-1 sm:gap-2 justify-center sm:justify-start">
                            <div className="tooltip" data-tip="Change Password">
                              <button
                                className="btn btn-xs sm:btn-sm hover:bg-green-200"
                                onClick={() => handleOpenChangePasswordModal(user._id, user.role)}
                              >
                                <i className="fas fa-key"></i>
                              </button>
                            </div>
                            <div className="tooltip" data-tip="Edit User">
                              <button
                                className="btn btn-xs sm:btn-sm bg-gray-300 hover:bg-gray-100"
                                onClick={() => handleEditUser(user._id)}
                              >
                                <i className="fas fa-edit"></i>
                              </button>
                            </div>
                            <div className="tooltip" data-tip="Remove User">
                              <button
                                className="btn btn-xs sm:btn-sm bg-red-500 hover:bg-red-300"
                                onClick={() => handleOpenDeleteModal(user._id)}
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* Modals */}
            <GeneralModal
              isVisible={generalModal.isVisible}
              message={generalModal.message}
              onClose={handleCloseGeneralModal}
              isSuccess={generalModal.isSuccess}
              className="z-[60]"
            />

            {showAddUserModal && (
              <AddUserModal
                newUser={newUser}
                setNewUser={setNewUser}
                handleAddUser={handleAddUser}
                handleCancelAddUser={handleCancelAddUser}
                errors={errors}
                hospitalOptions={hospitalOptions}
              />
            )}

            {showEditUserModal && (
              <EditUserModal
                editUser={editUser}
                setEditUser={setEditUser}
                handleSaveEditUser={handleSaveEditUser}
                setShowEditUserModal={setShowEditUserModal}
                errors={errors}
                hospitalOptions={hospitalOptions}
              />
            )}

            {showConfirmModal && (
              <ConfirmRemoveModal
                handleDeleteUser={handleDeleteUser}
                handleCloseModal={handleCloseModal}
              />
            )}

            {showChangePasswordModal && (
              <ChangePasswordModal
                currentUserRole={currentUserRole}
                passwordData={passwordData}
                setPasswordData={setPasswordData}
                handleChangePassword={handleChangePassword}
                handleCancelChangePassword={handleCancelChangePassword}
              />
            )}

            {/* Pagination */}
            <div className="mt-6">
              <PaginationUser
                currentPage={currentPage}
                totalUsers={filteredUsers.length}
                usersPerPage={usersPerPage}
                handlePreviousPage={handlePreviousPage}
                handleNextPage={handleNextPage}
                paginate={paginate}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UserManagement;